import { createSlice } from "@reduxjs/toolkit";
import { IHouseHoldPlanRate, IShelfPlanAdminCost, IShelfPlanInformation } from "components/houseHold/shelfPlans/information/Information.interface";
import { IHouseHoldPlanServiceRateConfiguration } from "container/houseHold/planSetup/b2c/shelfPlans/services/shelfPlanService.interface";
import { RootState } from "redux/store";
import { SALE_POINTS } from "shared/constant";
import { IListOfValues } from "shared/interface/types";

interface IHouseHoldInitialState {
  ShelfPlan: IShelfPlanInformation;
  ActivePriceSalePoint: keyof typeof SALE_POINTS;
  ShelfPlanAdminCost: IShelfPlanAdminCost;
  HouseHoldPlanRateConfiguration: IHouseHoldPlanRate[];
  HouseHoldPlanActivePlans: string[];
  HouseHoldPlanService: {
    id: string;
    houseHoldPlanServiceRateConfiguration?: IHouseHoldPlanServiceRateConfiguration[];
    service?: { contribution: IListOfValues; id: number; name: string };
  };
}
const initialState: IHouseHoldInitialState = {
  ShelfPlan: {
    houseHoldPlanGenders: [],
    planTypeId: 0,
    priceTypeId: 0,
    id: "",
    takafulProviderId: 0,
    productName: "",
    salePoint: [],
    renewalMinAge: 0,
    renewalMaxAge: 0
  },
  HouseHoldPlanService: {
    id: ""
  },
  ActivePriceSalePoint: "",
  ShelfPlanAdminCost: {
    adminCostMax: 0,
    adminCostMaxTypeId: 0,
    adminCostMin: 0,
    adminCostMinTypeId: 0
  },
  HouseHoldPlanRateConfiguration: [],
  HouseHoldPlanActivePlans: []
};

const houseHoldSlice = createSlice({
  name: "houseHold",
  initialState,
  reducers: {
    AddHouseHoldShelfPlan: (state, action) => {
      state.ShelfPlan = action.payload;
    },
    AddHouseHoldPlanService: (state, action) => {
      state.HouseHoldPlanService = action.payload;
    },
    DeleteHouseHoldShelfPlan: state => {
      state.ShelfPlan = initialState.ShelfPlan;
    },
    UpdateActiveSalePoint: (state, action) => {
      state.ActivePriceSalePoint = action.payload;
    },
    UpdateAdminCostForShelfPlanPrice: (state, action) => {
      state.ShelfPlanAdminCost = action.payload;
    },
    UpdateHouseHoldPlanRateConfiguration: (state, action) => {
      state.HouseHoldPlanRateConfiguration = action.payload;
    },
    UpdateHouseHoldActivePlan: (state, action) => {
      state.HouseHoldPlanActivePlans = action.payload;
    }
  }
});

export const {
  AddHouseHoldShelfPlan,
  DeleteHouseHoldShelfPlan,
  UpdateActiveSalePoint,
  UpdateAdminCostForShelfPlanPrice,
  UpdateHouseHoldPlanRateConfiguration,
  UpdateHouseHoldActivePlan,
  AddHouseHoldPlanService
} = houseHoldSlice.actions;
export default houseHoldSlice.reducer;

export const getHouseHoldShelfPlan = (state: RootState): IHouseHoldInitialState => state.houseHold;
